export default __webpack_public_path__ + "static/media/multicolorCat.eafaec08.jpg";